angular.module('dnecom').controller('UpsellController', ["$scope", "$http", "notifications", "$uibModal", function($scope, $http, notifications, $uibModal) {
    $scope.upsells = TemplateData.value('upsells');
    $scope.store = TemplateData.value('store');

    $scope.data = {
        activeRules: null,
        typeSelectorVisible: false
    };

    $scope.init = function() {
        sortUpsells();

        $(window).click(function () {
            if ($scope.data.typeSelectorVisible) {
                $scope.data.typeSelectorVisible = false;
                $scope.$apply();
            }
        });
    };

    $scope.addUpsell = function(event) {
        event.preventDefault();
        event.stopPropagation();

        $scope.data.typeSelectorVisible = true;
    };

    $scope.isTypeSelectorVisible = function() {
        return $scope.data.typeSelectorVisible;
    };

    $scope.move = function(upsell, index, direction) {
        $http.patch(
            Routing.generate('api_upsell_move', {
                store: $scope.store.id,
                upsell: upsell.id,
                direction: direction
            })
        ).then(function(response) {
            if (!response.data.success) {
                notifications.danger(response.data.message || 'Invalid server response.');
                return;
            }

            $scope.upsells[index] = response.data.upsell;

            for (var i = 0; i < $scope.upsells.length; i++) {
                if ($scope.upsells[i].id == response.data.upsell2.id) {
                    $scope.upsells[i] = response.data.upsell2;
                    break;
                }
            }

            sortUpsells();

            notifications.success('Upsell has been moved.');
        }, function() {
            notifications.danger('Invalid server response.');
        });
    };

    $scope.enable = function(upsell) {
        $http
            .patch(Routing.generate('api_upsell_change_status', {
                'store' : $scope.store.id,
                'upsell' : upsell.id || 0,
                'status' : 1
            }))
            .then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message);
                    return;
                }

                upsell.enabled = true;

                notifications.success('Upsell enabled successfully');
            }, function() {
                notifications.danger('Invalid server response.');
            })
        ;
    };

    $scope.disable = function(upsell) {
        $http
            .patch(Routing.generate('api_upsell_change_status', {
                'store' : $scope.store.id,
                'upsell' : upsell.id || 0,
                'status' : 0
            }))
            .then(function(response) {
                if (!response.data.success) {
                    $uibModal.open({
                        templateUrl: 'alert-modal.html',
                        controller: 'AlertModalInstanceCtrl',
                        controllerAs: '$ctrl',
                        resolve: {
                            message: function () {
                                return response.data.message || 'Failed to disable upsell.';
                            },
                            upsells: function () {
                                return response.data.upsells;
                            },
                            store: function () {
                                return $scope.store;
                            }
                        }
                    });
                    // notifications.danger(response.data.message);
                    return;
                }

                upsell.enabled = false;

                notifications.success('Upsell disabled successfully');
            }, function() {
                notifications.danger('Invalid server response.');
            })
        ;
    };

    $scope.delete = function(upsell, index) {
        $http.delete(
            Routing.generate('api_upsell_delete', {
                store: $scope.store.id,
                upsell: upsell.id
            })
            ).then(function(response) {
                if (!response.data.success) {
                    $uibModal.open({
                        templateUrl: 'alert-modal.html',
                        controller: 'AlertModalInstanceCtrl',
                        controllerAs: '$ctrl',
                        resolve: {
                            message: function () {
                                return response.data.message || 'Failed to delete upsell.';
                            },
                            upsells: function () {
                                return response.data.upsells;
                            },
                            store: function () {
                                return $scope.store;
                            }
                        }
                    });
                    return;
                }

                $scope.upsells.splice(index, 1);
                notifications.success('Upsell deleted successfully.');
            }, function() {
                notifications.danger('Invalid server response.');
            }
        );
    };

    function sortUpsells() {
        $scope.upsells = $scope.upsells.sort(function(a, b) {
            if (a.priority === b.priority) {
                return a.id < b.id ? -1 : 1;
            }

            return a.priority < b.priority ? -1 : 1;
        });
    }
}]);

angular.module('dnecom').controller('AlertModalInstanceCtrl', ["$uibModalInstance", "message", "store", "upsells", function($uibModalInstance, message, store, upsells) {
    var $ctrl = this;
    $ctrl.message = message;
    $ctrl.upsells = upsells;
    $ctrl.store = store;

    $ctrl.ok = function () {
        $uibModalInstance.close();
    };
}]);



